import React, { useEffect } from 'react';
import Emoji from '../components/Emoji';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

const Quickconnect = ({setUser}) => {

  const { userUid } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    console.log(userUid)
    if(localStorage.getItem("user")){
      navigate("/home");
    }
    else{
      axios.post('https://connivence-salon.net/api/e-learning/users/quickconnect.php', new URLSearchParams({
        uid: userUid
      })).then(response => {
        if(response.data.content.error && response.data.content.error === "NOT GOOD"){
          navigate("/login");
        }
        else{
          localStorage.setItem("user", JSON.stringify(response.data.content));
          setUser(response.data.content[0]);
          navigate("/pin");
        }
      }).catch(error => {
        // Gérer l'erreur ici, par exemple en affichant un message d'erreur
        console.error('Erreur lors de l\'envoi de la requête:', error);
        // Peut-être définir un état pour afficher l'erreur dans le popup
      });
    }
  }, [])

  return (
    <main className='quickconnect-component'>
      <div>
        <Emoji src="sparkles" children={true} />
        <p>Patience, la magie opère...</p>
      </div>
    </main>
  );
};

export default Quickconnect;